import { ChartArcIcon } from './ChartArcIcon';

/**
 * author: Austin Andrews
 * id 98939E5B-1528-4A2F-B35A-C37C60C75D93
 * name chart-arc
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-arc.svg
 * tags
 * - Math 
 */
export const ReportArcIcon = ChartArcIcon;
export default ReportArcIcon